import request from '@/libs/request'
import {plantProductionChangeShowSourceApi} from "@/api/processing/processing/plantProduction";

// 牛场出栏记录 列表
export function cattleOutListApi (data) {
  return request({
    url: `cattleFarm/cattleOut`,
    method: 'get',
    params: data
  })
}

// 牛场出栏记录 详情
export function cattleOutDetailApi (id) {
  return request({
    url: `cattleFarm/cattleOut/` + id,
    method: 'get'
  })
}


// 牛场出栏记录 编辑/添加
export function cattleOutSaveApi (data) {
  return request({
    url: `cattleFarm/cattleOut`,
    method: 'post',
    data: data
  })
}

// 牛场出栏记录 删除
export function cattleOutDelApi (id) {
  return request({
    url: `cattleFarm/cattleOut/` + id,
    method: 'delete'
  })
}

// 牛场出栏溯源
export function cattleOutTraceabilityCodeApi (id) {
  return request({
    url: `cattleFarm/cattleOutApi/traceabilityCode/` + id,
    method: 'get',
    responseType: 'blob',
  })
}

// 牛场出栏 切换溯源状态
export function cattleOutChangeShowSourceApi (id) {
  return request({
    url: `cattleFarm/cattleOutApi/changeShowSource/` + id,
    method: 'post'
  })
}


